import { combineReducers } from "redux";
import calculateMargin from "./CalculateMargin";
export default combineReducers({ calculateMargin });
